const PPRA_CERTIFICATE_VERIFY_BASE_URL =
  "https://ffcportal.theppra.org.za/api/certificates/verify";

export function buildPpraCertificateVerifyUrl(certificateNumber: string): string {
  const normalizedNumber = certificateNumber.trim();
  return `${PPRA_CERTIFICATE_VERIFY_BASE_URL}/${encodeURIComponent(normalizedNumber)}`;
}
